import type { WorkspaceData } from "../types";

const activityDefinition = "Conjunto de tareas que tiene por finalidad reducir el riesgo de desastres, cuya ocurrencia puede poner en peligro la capacidad de la entidad.";
const normativeBasis = "Ley N.º 29664, Ley del Sistema Nacional de Gestión del Riesgo de Desastres.\nDecreto Supremo 048-2011-PCM, que aprueba su reglamento.\nGuía para el Planeamiento Institucional del CEPLAN y modificatorias.";
const taskDefinitions: Record<string, string> = {
  "E1.01.01.01": "Consiste en las acciones de gestión y representación que ejerce la máxima autoridad.",
  "E1.01.01.02": "El Titular del SIS aprueba los planes institucionales, el presupuesto institucional, documentos de gestión, informes de evaluación y otros documentos institucionales.",
  "E1.01.01.03": "El Titular del SIS aprueba los informes de evaluación de impacto de los planes institucionales del SIS.",
  "E1.01.01.04": "El Titular del SIS aprueba la Memoria Anual Institucional, documento que evidencia el quehacer y los logros alcanzados durante el año fiscal.",
};
const definitionMetadata = { activityOperationalDefinition: activityDefinition, normativeBasis, definitionResponsible: "01 - JEFATURA", definitionUpdatedOn: "2025-11-05" };

export const demoWorkspace: WorkspaceData = {
  profile: {
    id: "demo-admin",
    fullName: "Administrador POI",
    email: "admin@sis.gob.pe",
    role: "admin",
  },
  costCenters: [
    { id: "cc-jefatura", code: "01", name: "JEFATURA" },
    { id: "cc-asegurado", code: "01.01", name: "GERENCIA DEL ASEGURADO" },
  ],
  selectedCenterId: "cc-jefatura",
  cycle: {
    id: "cycle-2026",
    year: 2026,
    name: "Primera reprogramación POI 2026",
    status: "open",
    registrationEnabled: true,
    officialVersionNumber: null,
    officializedAt: null,
    months: Array.from({ length: 12 }, (_, index) => ({ month: index + 1, enabled: true })),
    sourceFile: "20260703 - POI2026_ AO y Tareas v8.2.xlsx",
    sourceImportedAt: "2026-07-03T00:00:00-05:00",
  },
  submissionId: "submission-demo",
  submissionStatus: "draft",
  allowedMonths: null,
  taskJustifications: {},
  tasks: [
    {
      id: "task-1",
      legacyKey: "01E1.01.01.01",
      activityCode: "E1.01.01",
      activityName: "Conducción de la política institucional",
      taskCode: "E1.01.01.01",
      taskName: "Conducción y representación",
      baselineVersionNumber: 0,
      unit: "Acción",
      operationalDefinition: taskDefinitions["E1.01.01.01"],
      ...definitionMetadata,
      baseline: [1, 1, 1, 0, 0, 1, 0, 1, 0, 1, 1, 1],
      modified: Array(12).fill(null),
    },
    {
      id: "task-2",
      legacyKey: "01E1.01.01.02",
      activityCode: "E1.01.01",
      activityName: "Conducción de la política institucional",
      taskCode: "E1.01.01.02",
      taskName: "Aprobación de documentos de gestión",
      unit: "Acción",
      baseline: [1, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0],
      operationalDefinition: taskDefinitions["E1.01.01.02"],
      ...definitionMetadata,
      baselineVersionNumber: 2,
      modified: [null, null, null, null, null, null, null, 1, null, null, null, null],
    },
    {
      id: "task-3",
      legacyKey: "01E1.01.01.03",
      activityCode: "E1.01.01",
      activityName: "Conducción de la política institucional",
      taskCode: "E1.01.01.03",
      taskName: "Aprobación de informes de evaluación de planes",
      unit: "Acción",
      baselineVersionNumber: 1,
      operationalDefinition: taskDefinitions["E1.01.01.03"],
      ...definitionMetadata,
      baseline: [1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0],
      modified: Array(12).fill(null),
    },
    {
      id: "task-4",
      legacyKey: "01E1.01.01.04",
      activityCode: "E1.01.01",
      activityName: "Conducción de la política institucional",
      taskCode: "E1.01.01.04",
      taskName: "Aprobación de la Memoria Anual Institucional",
      unit: "Acción",
      baselineVersionNumber: 0,
      operationalDefinition: taskDefinitions["E1.01.01.04"],
      ...definitionMetadata,
      baseline: [0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0],
      modified: Array(12).fill(null),
    },
  ],
  versions: [],
  validationStatus: "not_required",
  validationObservation: null,
};
